
/**
 * Map object
 * Load and setup tilemaps.
 * Includes all collision and interactin info.
 */
Game.Utils.Map = {

	// VARIABLES

	// Loaded map.
	map: null,

	// Different zones.
	zones: {},

	// Layers.
	layer: null,
	layer_details_top: null,
	layer_details_bottom: null,
	layer_collision: null,
	layer_properties: null,

	// Player Start Data
	player_position: {},

	// Standard regions
	// region_start: null,
	// region_finish: null,

	start_position: null,


	// CONSTANTS

	// Tile dimensions.
	TILE_SIZE: 8,
	TILE_HALF_SIZE: 4,

	// Tile id for left side only collision tile.
	LEFT_WALL: 11 + 3073,

	// Tile id for right side only collision tile.
	RIGHT_WALL: 12 + 3073,

	TOP_WALL: 10 + 3073,

	BOTTOM_WALL: 13 + 3073,

	// Number of pixels above the collision object you need to be in order to trigger a collision.
	TILE_COLLISION_OFFSET: -2,

	// Top collision tile.
	TILE_COLLISION: 8 + 3073,

	TILE_UNPASSABLE: 9 + 3073,

	// Water tile.
	TILE_WATER: 989,

	TILE_LADDER: 14 + 3073,


	load_room: function( map_name, layers, params ) {

		params.texture = 'rooms';

		this.load( map_name, layers, params );

	},


	load_world: function( map_name, layers, params ) {

		params.texture = 'world';

		this.load( map_name, layers, params );

	},

	/**
	 * Load level
	 */
	load: function( map_name, layers, params ) {

		// setup map
		this.map = game.add.tilemap( map_name );

		this.map.addTilesetImage( params.texture );
		this.map.addTilesetImage( 'collision' );

		this.map.setCollision( [ this.TILE_COLLISION ], true, 'collision' );

		// Add map layers.
		this.layer = this.map.createLayer( 'tiles' );
		layers.groupLevelBottom.add( this.layer );

		this.resize_world();

		// Details Top
		// These are drawn on top of the player.
		this.layer_details_top = this.map.createLayer( 'details_top' );
		layers.groupLevelTop.add( this.layer_details_top );

		// Details Bottom
		// These display under the player, and on top of the world map.
		this.layer_details_bottom = this.map.createLayer( 'details_bottom' );
		layers.groupLevelBottom.add( this.layer_details_bottom );

		this.layer_collision = this.map.createLayer( 'collision' );
		layers.groupLevelTop.add( this.layer_collision );

		this.layer_properties = this.map.createLayer( 'properties' );
		layers.groupLevelTop.add( this.layer_properties );

		// Hide debug layers if not in debug mode.
		if ( !Game.debug ) {

			this.layer_collision.visible = false;
			this.layer_properties.visible = false;

		}

		this.set_all_tile_collision();

		// position player
		var player_position = this.find_objects_by_type( 'start', this.map, 'objects' );

		if ( params.checkpoint ) {
			player_position = this.find_objects_by_name( params.checkpoint, this.map, 'objects' );
		}

		if ( player_position[ 0 ] ) {

			// use the first result - there should only be 1 start point per level
			// if there isn't we'll just ignore the others
			this.player_position.x = parseInt( player_position[ 0 ].x + this.TILE_HALF_SIZE );
			this.player_position.y = parseInt( player_position[ 0 ].y );

		}

		// Zones.
		this.zones = this.find_objects_by_type( '', this.map, 'zones' );

	},


	add_zone: function( properties ) {

		var defaultProperties = {
			height: Game.Utils.Map.TILE_SIZE,
			width: Game.Utils.Map.TILE_SIZE,
			name: '',
			rectangle: true,
			rotation: 0,
			type: '',
			visible: true,
			x: 0,
			y: 0,
		};

		var newProperties = Object.assign( defaultProperties, properties );

		// console.log( 'new zone', newProperties );

		this.zones.push( newProperties );

	},


	/**
	 * Find objects in a Tiled layer that have the type equal to a certain value.
	 *
	 * @param   {String}     type   The object type to find, as specified in the map file
	 * @param   {Object}     map    Tilemap bject
	 * @param   {String}     layer  Key for object layer to search
	 * @returns {Array}      List of objects
	 */
	find_objects_by_type: function( type, map, layer ) {

		var result = new Array();

		map.objects[ layer ].forEach(

			function( element ) {

				if ( '' !== type ) {

					if ( typeof element.type !== 'undefined' && element.type.toLowerCase() === type.toLowerCase() ) {

						result.push( element );

					}

				} else {

					result.push( element );

				}

			}

		);

		return result;

	},


	/**
	 * Find objects in a Tiled layer that have the name equal to a certain value.
	 *
	 * @param   {String}     name   The object type to find, as specified in the map file
	 * @param   {Object}     map    Tilemap bject
	 * @param   {String}     layer  Key for object layer to search
	 * @returns {Array}      List of objects
	 */
	find_objects_by_name: function( name, map, layer ) {

		var result = new Array();

		map.objects[ layer ].forEach(

			function( element ) {

				if ( '' !== name ) {

					if ( typeof element.name !== 'undefined' && element.name.toLowerCase() === name.toLowerCase() ) {

						result.push( element );

					}

				} else {

					result.push( element );

				}

			}

		);

		return result;

	},


	/**
	 * Set tile collision properties.
	 *
	 * Allows collisions on a single side of the tile.
	 *
	 * @param  {Object} 	mapLayer The map layer to scan.
	 * @param  {Int} 		id       The id of the tile to apply the collision to.
	 * @param  {directions} dirs     An object with the direction settings desired.
	 */
	set_all_tile_collision: function() {

		// top = 0
		// right = 1
		// bottom = 2
		// left = 3

		var collision = [];
		collision[ this.RIGHT_WALL ] = [ false, true, false, false ];
		collision[ this.LEFT_WALL ] = [ false, false, false, true ];
		collision[ this.BOTTOM_WALL ] = [ false, false, true, false ];
		collision[ this.TOP_WALL ] = [ true, false, false, false ];

		// get the 2-dimensional tiles array for this layer
		var d = this.layer_collision.map.layers[ this.layer_collision.index ].data;

		for ( var i = 0; i < d.length; i++ ) {

			for ( var j = 0; j < d[ i ].length; j++ ) {

				if ( collision[ d[ i ][ j ].index ] ) {

					this.set_tile_collision( j, i, collision[ d[ i ][ j ].index ] );

				}

			}

		}

	},


	set_tile_collision: function( x, y, collision, tile_index ) {

		var d = this.layer_collision.map.layers[ this.layer_collision.index ].data;

		var t = d[ y ][ x ];

		if ( !t ) {
			return;
		}

		if ( tile_index ) {
			t.index = tile_index;
		}

		t.collideUp = collision[ 0 ];
		t.collideDown = collision[ 2 ];
		t.collideLeft = collision[ 3 ];
		t.collideRight = collision[ 1 ];

		t.faceTop = collision[ 0 ];
		t.faceBottom = collision[ 2 ];
		t.faceLeft = collision[ 3 ];
		t.faceRight = collision[ 1 ];

	},


	add_tile_collision: function( tiles, tile_index, collision ) {

		for ( var i = 0; i < tiles.length; i++ ) {

			this.set_tile_collision( tiles[ i ][ 0 ], tiles[ i ][ 1 ], collision, tile_index );

		}

	},


	/**
	 * Resize the world so that it remains central to the camera viewport.
	 */
	resize_world: function() {

		// Use the main game tilemap since that will have the most tiles on it.
		var layer = this.layer.layer;

		// Work out how big the world should be.
		//
		// This uses the screen width to ensure the map is centered.
		// If the map width is less than the screen width then a bit of extra
		// space is added.
		var layer_width = Math.max( layer.widthInPixels, game.width ) * game.world.scale.x;
		var layer_height = Math.max( layer.heightInPixels, game.height ) * game.world.scale.y;

		// The map is offset slightly based on the size of the map against the
		// screen.
		//
		// This ensures the map isn't locked to the top left corner.
		var offset_x = 0;
		var offset_y = 0;

		if ( layer_width === game.width ) {
			offset_x = Math.floor( ( layer_width - layer.widthInPixels ) / -2 );
		}

		if ( layer_height === game.height ) {
			offset_y = Math.floor( ( layer_height - layer.heightInPixels ) / -2 );
		}

		game.world.setBounds( offset_x, offset_y, layer_width, layer_height );

	},


	/**
	 * Check to see if the current zone has the specified custom property.
	 *
	 * @param  {Object} zone     The object defining the property to check.
	 * @param  {string} property The property key to search for.
	 * @return {boolean}         [description]
	 */
	zone_has_property: function( zone, property ) {

		if ( 'undefined' !== typeof zone.properties && 'undefined' !== typeof zone.properties[ property ] ) {
			return true;
		}

		return false;

	},


	/**
	 * Does the x, y position overlap water.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_water: function( x, y ) {

		return this.point_overlap( x, y, this.layer_properties, this.TILE_WATER );

	},


	/**
	 * Does the x, y position overlap a ladder.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_ladder: function( x, y ) {

		return this.point_overlap( x, y, this.layer_properties, this.TILE_LADDER );

	},


	/**
	 * Does the x, y position collide with anything?
	 * Ignores side only tiles.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_collision: function( x, y ) {

		return this.point_overlap( x, y, this.layer_collision, this.TILE_COLLISION );

	},


	/**
	 * Does the specified point overlap the specified tile type on the specified tile layer?
	 *
	 * @param  {Int} 	x          X pixel coordinate to check.
	 * @param  {Int} 	y          Y pixel coordinate to check.
	 * @param  {Object} tile_layer Tile layer to check against.
	 * @param  {Int} 	tile_index Tile index we are looking for.
	 * @return {bool}
	 */
	point_overlap: function( x, y, tile_layer, tile_index ) {

		// Make sure the tile index, and layer are set.
		if ( !tile_index || !tile_layer ) {
			return false;
		}

		var tile = this.get_tile( x, y, tile_layer );

		if ( !tile ) {
			return false;
		}

		// If the tile index is the desired tile type then return true.
		if ( tile.index && tile_index === tile.index ) {
			return true;
		}

		// If we got this far then it's not a match.
		return false;

	},


	/**
	 * Get the tile data for the tile at the specified x, y coordinate.
	 *
	 * @param  {Number} x          The x position of the tile.
	 * @param  {Number} y          The y position of the tile.
	 * @param  {Object} tile_layer The Game.Utils.Map tile layer object.
	 * @return {Object}
	 */
	get_tile: function( x, y, tile_layer ) {

		// Get tile at specified coordinates.
		var tiles = tile_layer.getTiles( x, y, 1, 1 );

		// No tiles found?
		if ( 0 === tiles.length ) {
			return false;
		}

		// Since we're checking for a point it will only be one tile.
		return tiles[ 0 ];

	},


	/**
	 * Convert a number into an absolute position.
	 *
	 * @param  {Number} pixel_position The position of the tile.
	 * @return {Number}
	 */
	tile_coord: function( pixel_position ) {

		return Math.floor( pixel_position / this.TILE_SIZE ) * this.TILE_SIZE;

	},


	/**
	 * Do stuff when there's a collision
	 */
	player_collision_callback: function( player, tile ) {

		// Game is over so no need to continue.
		if ( 'play' !== Game.game_state ) {

			return;

		}

		// If player hits head on ceiling then stop ascent.
		if ( player.body.blocked.up ) {

			player.body.jumpHeight = 9999999;
			player.body.velocity.y = 0;

		}

		if ( player.body.blocked.down ) {
			if ( Math.abs( Math.round( player.body.y ) - player.body.y ) < 0.1 ) {
				player.body.y = Math.round( player.body.y );
			}
		}

		if ( player.state === Game.Prefabs.Man.states.DIVE ) {
			player.state === Game.Prefabs.Man.states.FALL;
		}

		// Slide down walls.
		// Only triggered if the player is falling, and if their direction is downwards.
		if ( player.state === Game.Prefabs.Man.states.FALL && player.body.velocity.y > -2 ) {

			if ( player.body.blocked.left && player.controls.left ) {

				if ( Game.Utils.PlayerPhysics.can_wall_slide( player ) ) {
					player.state = Game.Prefabs.Man.states.WALL_SLIDE;
				}

			}

			if ( player.body.blocked.right && player.controls.right ) {

				if ( Game.Utils.PlayerPhysics.can_wall_slide( player ) ) {
					player.state = Game.Prefabs.Man.states.WALL_SLIDE;
				}

			}

		}

		// Dust cloud on big landing.
		if ( player.body.blocked.down ) {

			// Smaller jumps.
			// nothing.

			// Medium & large jumps.
			if ( player.deltaY > 1.4 ) {

				new Game.Prefabs.EffectDustJump( game, player.x, player.y );

			}

			if ( player.deltaY < -5 ) {

				player.state = Game.Prefabs.Man.states.CLIMB_PLATFORM;
				player.pause( 500 );

			}

		}



		// If player hits wall, and is moving upwards, and slightly across then stop ascent.
		// if ( player.body.velocity.y < 0 && Math.abs( player.deltaX ) > 0.5 ) {

		// 	// console.log( 'stop' );
		// 	player.body.jumpHeight = 9999999;
		// 	player.body.velocity.y = 0;

		// }

	},


	/**
	 * Pre collision checks to ensure the player is treated nicely.
	 *
	 * @param  {[type]} player [description]
	 * @param  {[type]} tile   [description]
	 * @return {[type]}        [description]
	 */
	player_collision_check: function( player, tile ) {

		// Default.
		return true;

	},


	/**
	 * Generate a cache slug for the current level.
	 *
	 * @param  {[type]} path [description]
	 * @return {[type]}      [description]
	 */
	map_slug: function( path ) {

		var slug = path;

		slug = slug.replace( /\//g, '-' );
		slug = slug.toLowerCase();
		slug = slug.replace( '.json', '' );

		return slug;

	},


	/**
	 * Draw a rectangle indicating the different zones available.
	 */
	debug_zones: function() {

		this.zones.forEach(
			function( zone ) {
				game.debug.rectangle( zone );
			}
		);

	},

};
